import { Button, Typography, Avatar } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { loginStore } from "@/store/loginStore";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const { user, token, logoutFontend } = loginStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutFontend();
    navigate("/login");
  };

  if (!token || !user) {
    return (
      <section className="container flex flex-col items-center justify-center gap-4 pt-20">
        <Avatar size={64} icon={<UserOutlined />} />
        <Typography.Text>Bạn chưa đăng nhập</Typography.Text>
        <Button type="primary" onClick={() => navigate("/login")}>
          Đăng nhập
        </Button>
      </section>
    );
  }

  return (
    <section className="container h-full">
      <div className="flex flex-col items-center gap-3 py-6">
        <Avatar src={user?.avatar || ""} size={64} icon={<UserOutlined />} className="bg-blue-500" />
        <Typography.Title level={4} className="mb-0!">
          {user.name || "Chưa cập nhật"}
        </Typography.Title>
      </div>

      <div className="flex flex-col gap-3 rounded-xl bg-white p-4">
        <div className="flex justify-between border-b border-gray-100 pb-3">
          <Typography.Text type="secondary">Email</Typography.Text>
          <Typography.Text>{user.email}</Typography.Text>
        </div>
        <div className="flex justify-between border-b border-gray-100 pb-3">
          <Typography.Text type="secondary">Số điện thoại</Typography.Text>
          <Typography.Text>{user.phone || "Chưa cập nhật"}</Typography.Text>
        </div>
        <div className="flex justify-between">
          <Typography.Text type="secondary">Trạng thái</Typography.Text>
          <Typography.Text>{user.status === "active" ? "Hoạt động" : "Ngưng hoạt động"}</Typography.Text>
        </div>
      </div>

      <Button danger icon={<LogoutOutlined />} onClick={handleLogout} className="mt-6 w-full" size="large">
        Đăng xuất
      </Button>
    </section>
  );
}
